<section>
  <div class="empty-state">
    <opac-no-results-default></opac-no-results-default>
  </div>
  <div class="custom-empty-state">
    <ng-content select="[slot='custom-svg']"></ng-content>
  </div>

  <h3>{{ label }}</h3>

  <ng-content select="opac-no-results-cta"></ng-content>

  <ng-content></ng-content>
</section>